import { Routes } from '@angular/router';

export const vendorRoutes: Routes = [
  // Vendor Incoterm
  {
    path: 'vendor-incoterm',
    data: { moduleCode: 'vdr_incoterm' },
    children: [
      { path: '', loadComponent: () => import('./vendor-incoterm/vendor-incoterm').then((m) => m.VendorIncoterm) },
      {
        path: 'add',
        loadComponent: () =>
          import('./vendor-incoterm/vendor-incoterm-details/vendor-incoterm-details').then((m) => m.VendorIncotermDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./vendor-incoterm/vendor-incoterm-details/vendor-incoterm-details').then((m) => m.VendorIncotermDetails)
      },
      {
        path: 'incoterm-import',
        loadComponent: () => import('./vendor-incoterm/vendor-incoterm-import/vendor-incoterm-import').then((m) => m.VendorIncotermImport)
      }
    ]
  },

  // Vendor Shipment
  {
    path: 'vendor-shipment',
    data: { moduleCode: 'vdr_ship_mode' },
    children: [
      { path: '', loadComponent: () => import('./vendor-shipment/vendor-shipment').then((m) => m.VendorShipment) },
      {
        path: 'add',
        loadComponent: () =>
          import('./vendor-shipment/vendor-shipment-details/vendor-shipment-details').then((m) => m.VendorShipmentDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./vendor-shipment/vendor-shipment-details/vendor-shipment-details').then((m) => m.VendorShipmentDetails)
      },
      {
        path: 'shipment-import',
        loadComponent: () => import('./vendor-shipment/vendor-shipment-import/vendor-shipment-import').then((m) => m.VendorShipmentImport)
      }
    ]
  },

  // Vendor Port
  {
    path: 'vendor-port',
    data: { moduleCode: 'vdr_port' },
    children: [
      { path: '', loadComponent: () => import('./vendor-port/vendor-port').then((m) => m.VendorPort) },
      {
        path: 'add',
        loadComponent: () => import('./vendor-port/vendor-port-details/vendor-port-details').then((m) => m.VendorPortDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./vendor-port/vendor-port-details/vendor-port-details').then((m) => m.VendorPortDetails)
      },
      {
        path: 'port-import',
        loadComponent: () => import('./vendor-port/vendor-port-import/vendor-port-import').then((m) => m.VendorPortImport)
      }
    ]
  },

  // Vendor Carrier Route
  {
    path: 'vendor-carrier-route',
    data: { moduleCode: 'vdr_carrier_route' },
    children: [
      { path: '', loadComponent: () => import('./vendor-carrier-route/vendor-carrier-route').then((m) => m.VendorCarrierRoute) },
      {
        path: 'add',
        loadComponent: () =>
          import('./vendor-carrier-route/vendor-carrier-route-details/vendor-carrier-route-details').then(
            (m) => m.VendorCarrierRouteDetails
          )
      },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./vendor-carrier-route/vendor-carrier-route-details/vendor-carrier-route-details').then(
            (m) => m.VendorCarrierRouteDetails
          )
      },
      {
        path: 'carrier-route-import',
        loadComponent: () =>
          import('./vendor-carrier-route/vendor-carrier-route-import/vendor-carrier-route-import').then((m) => m.VendorCarrierRouteImport)
      }
    ]
  },

  // Vendor Group
  {
    path: 'vendor-group',
    data: { moduleCode: 'vdr_vdr_grp' },
    children: [
      { path: '', loadComponent: () => import('./vendor-group/vendor-group').then((m) => m.VendorGroup) },
      {
        path: 'add',
        loadComponent: () => import('./vendor-group/vendor-group-details/vendor-group-details').then((m) => m.VendorGroupDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./vendor-group/vendor-group-details/vendor-group-details').then((m) => m.VendorGroupDetails)
      },
      {
        path: 'group-import',
        loadComponent: () => import('./vendor-group/vendor-group-import/vendor-group-import').then((m) => m.VendorGroupImport)
      }
    ]
  },

  // Vendor Profile
  {
    path: 'vendor-profile',
    data: { moduleCode: 'vdr_vdr_profile' },
    children: [
      { path: '', loadComponent: () => import('./vendor-profile/vendor-profile').then((m) => m.VendorProfile) },
      {
        path: 'add',
        loadComponent: () => import('./vendor-profile/vendor-profile-details/vendor-profile-details').then((m) => m.VendorProfileDetails)
      },
      {
        path: 'details/:id',
        loadComponent: () => import('./vendor-profile/vendor-profile-details/vendor-profile-details').then((m) => m.VendorProfileDetails)
      },
      {
        path: 'profile-import',
        loadComponent: () => import('./vendor-profile/vendor-profile-import/vendor-profile-import').then((m) => m.VendorProfileImport)
      }
    ]
  },

  // Blacklisted Vendor
  {
    path: 'blacklisted-vendor',
    data: { moduleCode: 'vdr_blacklisted_vdr' },
    children: [
      { path: '', loadComponent: () => import('./blacklisted-vendor/blacklisted-vendor').then((m) => m.BlacklistedVendor) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./blacklisted-vendor/blacklisted-vendor-details/blacklisted-vendor-details').then((m) => m.BlacklistedVendorDetails)
      }
      // { path: 'group-import', component: VendorGroupImport }
    ]
  },

  // New Vendor Request
  {
    path: 'new-vendor',
    data: { moduleCode: 'vdr_new_vdr' },
    children: [
      { path: '', loadComponent: () => import('./new-vendor-req/new-vendor-req').then((m) => m.NewVendorReq) },
      {
        path: 'details/:id',
        loadComponent: () => import('./new-vendor-req/new-vendor-req-details/new-vendor-req-details').then((m) => m.NewVendorReqDetails)
      }
    ]
  },
  {
    path: 'vendor-details-update',
    data: { moduleCode: 'vdr_details_update' },
    children: [
      { path: '', loadComponent: () => import('./vendor-details-req/vendor-details-req').then((m) => m.VendorDetailsReq) },
      {
        path: 'details/:id',
        loadComponent: () => import('./vendor-details-req/vendor-update-details/vendor-update-details').then((m) => m.VendorUpdateDetails)
      }
    ]
  },

  // Blacklist Request
  {
    path: 'blacklist-vendor',
    data: { moduleCode: 'vdr_blacklist_reinstate' },
    children: [
      { path: '', loadComponent: () => import('./blacklist-req/blacklist-req').then((m) => m.BlacklistReq) },
      {
        path: 'details/:id',
        loadComponent: () => import('./blacklist-req/blacklist-req-details/blacklist-req-details').then((m) => m.BlacklistReqDetails)
      }
    ]
  },
  // UnBlacklist Request
  {
    path: 'unblacklist-vendor',
    data: { moduleCode: 'vdr_unblacklist_vdr' },
    children: [
      { path: '', loadComponent: () => import('./unblacklist-req/unblacklist-req').then((m) => m.UnblacklistReq) },
      {
        path: 'details/:id',
        loadComponent: () =>
          import('./unblacklist-req/unblacklist-req-details/unblacklist-req-details').then((m) => m.UnblacklistReqDetails)
      }
    ]
  }
];
